/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { OtherSystemCategory } from './OtherSystemCategory';
import {
    instanceOfOtherSystemCategory,
    OtherSystemCategoryFromJSON,
    OtherSystemCategoryFromJSONTyped,
    OtherSystemCategoryToJSON,
} from './OtherSystemCategory';

/**
 * @type OtherSystemSourceCategory
 * 
 * @export
 */
export type OtherSystemSourceCategory = OtherSystemCategory;

export function OtherSystemSourceCategoryFromJSON(json: any): OtherSystemSourceCategory {
    return OtherSystemSourceCategoryFromJSONTyped(json, false);
}

export function OtherSystemSourceCategoryFromJSONTyped(json: any, ignoreDiscriminator: boolean): OtherSystemSourceCategory {
    if (json == null) {
        return json;
    }
    if (instanceOfOtherSystemCategory(json)) {
        return OtherSystemCategoryFromJSONTyped(json, true);
    }

    return {} as any;
}

export function OtherSystemSourceCategoryToJSON(json: any): any {
    return OtherSystemSourceCategoryToJSONTyped(json, false);
}

export function OtherSystemSourceCategoryToJSONTyped(value?: OtherSystemSourceCategory | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    if (instanceOfOtherSystemCategory(value)) {
        return OtherSystemCategoryToJSON(value as OtherSystemCategory);
    }

    return {};
}

